import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Channel, ChannelListDto, ChannelResponse, CreateChannelDto } from './channels.model';

@Injectable({
  providedIn: 'root',
})
export class ChannelsService {
  private http = inject(HttpClient);
  private basePath = 'channels';

  findAll(filters: ChannelListDto): Observable<ChannelResponse> {
    let params = new HttpParams();

    if (filters.page !== undefined) {
      params = params.set('page', filters.page.toString());
    }
    if (filters.limit !== undefined) {
      params = params.set('limit', filters.limit.toString());
    }
    if (filters.search) {
      params = params.set('search', filters.search);
    }
    if (filters.status) {
      params = params.set('status', filters.status);
    }

    return this.http.get<ChannelResponse>(`/${this.basePath}`, { params });
  }

  create(data: CreateChannelDto): Observable<Channel> {
    return this.http.post<Channel>(`/${this.basePath}`, data);
  }

  checkCodeAvailability(code: string): Observable<{ available: boolean }> {
    return this.http.get<{ available: boolean }>(`/${this.basePath}/check-code`, {
      params: new HttpParams().set('code', code)
    });
  }

  activate(id: string): Observable<Channel> {
    return this.http.patch<Channel>(`/${this.basePath}/${id}/activate`, {});
  }

  deactivate(id: string): Observable<Channel> {
    return this.http.patch<Channel>(`/${this.basePath}/${id}/deactivate`, {});
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`/${this.basePath}/${id}`);
  }
}
